Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = require('airbnb-prop-types');

var _withStyles = require('../themes/withStyles');

var _adjustableSpacing = require('../constants/adjustableSpacing');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  top: _propTypes2['default'].number,
  topMediumAndAbove: _adjustableSpacing.adjustableSpacingShape,
  topLargeAndAbove: _adjustableSpacing.adjustableSpacingShape,
  bottom: _propTypes2['default'].number,
  bottomMediumAndAbove: _adjustableSpacing.adjustableSpacingShape,
  bottomLargeAndAbove: _adjustableSpacing.adjustableSpacingShape,
  left: _propTypes2['default'].number,
  leftMediumAndAbove: _adjustableSpacing.adjustableSpacingShape,
  leftLargeAndAbove: _adjustableSpacing.adjustableSpacingShape,
  right: _propTypes2['default'].number,
  rightMediumAndAbove: _adjustableSpacing.adjustableSpacingShape,
  rightLargeAndAbove: _adjustableSpacing.adjustableSpacingShape,
  horizontal: _propTypes2['default'].number,
  horizontalMediumAndAbove: _adjustableSpacing.adjustableSpacingShape,
  horizontalLargeAndAbove: _adjustableSpacing.adjustableSpacingShape,
  vertical: _propTypes2['default'].number,
  verticalMediumAndAbove: _adjustableSpacing.adjustableSpacingShape,
  verticalLargeAndAbove: _adjustableSpacing.adjustableSpacingShape,
  textInline: _propTypes2['default'].bool,
  inline: _propTypes2['default'].bool,
  children: _propTypes2['default'].node.isRequired
}));

var defaultProps = exports.defaultProps = {
  top: null,
  topMediumAndAbove: null,
  topLargeAndAbove: null,
  bottom: null,
  bottomMediumAndAbove: null,
  bottomLargeAndAbove: null,
  left: null,
  leftMediumAndAbove: null,
  leftLargeAndAbove: null,
  right: null,
  rightMediumAndAbove: null,
  rightLargeAndAbove: null,
  horizontal: null,
  horizontalMediumAndAbove: null,
  horizontalLargeAndAbove: null,
  vertical: null,
  verticalMediumAndAbove: null,
  verticalLargeAndAbove: null,
  inline: false,
  textInline: false
};

function Spacing(_ref) {
  var css = _ref.css,
      children = _ref.children,
      inline = _ref.inline,
      textInline = _ref.textInline,
      styles = _ref.styles,
      theme = _ref.theme,
      top = _ref.top,
      topMediumAndAbove = _ref.topMediumAndAbove,
      topLargeAndAbove = _ref.topLargeAndAbove,
      bottom = _ref.bottom,
      bottomMediumAndAbove = _ref.bottomMediumAndAbove,
      bottomLargeAndAbove = _ref.bottomLargeAndAbove,
      left = _ref.left,
      leftMediumAndAbove = _ref.leftMediumAndAbove,
      leftLargeAndAbove = _ref.leftLargeAndAbove,
      right = _ref.right,
      rightMediumAndAbove = _ref.rightMediumAndAbove,
      rightLargeAndAbove = _ref.rightLargeAndAbove,
      horizontal = _ref.horizontal,
      horizontalMediumAndAbove = _ref.horizontalMediumAndAbove,
      horizontalLargeAndAbove = _ref.horizontalLargeAndAbove,
      vertical = _ref.vertical,
      verticalMediumAndAbove = _ref.verticalMediumAndAbove,
      verticalLargeAndAbove = _ref.verticalLargeAndAbove;

  var computedTop = top != null ? top : vertical;
  var computedBottom = bottom != null ? bottom : vertical;
  var computedLeft = left != null ? left : horizontal;
  var computedRight = right != null ? right : horizontal;

  var computedStyles = Object.assign({}, computedTop !== null && { marginTop: computedTop * theme.unit }, computedBottom !== null && { marginBottom: computedBottom * theme.unit }, computedLeft !== null && { marginLeft: computedLeft * theme.unit }, computedRight !== null && { marginRight: computedRight * theme.unit });

  return _react2['default'].createElement(
    'div',
    css(inline && styles.inlineBlock, textInline && styles.inline, computedStyles, topMediumAndAbove != null && styles['topMediumAndAbove-' + String(topMediumAndAbove)], topLargeAndAbove != null && styles['topLargeAndAbove-' + String(topLargeAndAbove)], bottomMediumAndAbove != null && styles['bottomMediumAndAbove-' + String(bottomMediumAndAbove)], bottomLargeAndAbove != null && styles['bottomLargeAndAbove-' + String(bottomLargeAndAbove)], verticalMediumAndAbove != null && styles['verticalMediumAndAbove-' + String(verticalMediumAndAbove)], verticalLargeAndAbove != null && styles['verticalLargeAndAbove-' + String(verticalLargeAndAbove)], rightMediumAndAbove != null && styles['rightMediumAndAbove-' + String(rightMediumAndAbove)], rightLargeAndAbove != null && styles['rightLargeAndAbove-' + String(rightLargeAndAbove)], leftMediumAndAbove != null && styles['leftMediumAndAbove-' + String(leftMediumAndAbove)], leftLargeAndAbove != null && styles['leftLargeAndAbove-' + String(leftLargeAndAbove)], horizontalMediumAndAbove != null && styles['horizontalMediumAndAbove-' + String(horizontalMediumAndAbove)], horizontalLargeAndAbove != null && styles['horizontalLargeAndAbove-' + String(horizontalLargeAndAbove)]),
    children
  );
}

Spacing.componentCategory = 'Core';
Spacing.displayName = 'Spacing';
Spacing.propTypes = propTypes;
Spacing.defaultProps = defaultProps;

exports['default'] = (0, _withStyles.withStyles)(function (_ref2) {
  var unit = _ref2.unit,
      responsive = _ref2.responsive;

  var responsiveUnits = [0, 0.5, 1, 1.5, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  var marginStyles = {};

  responsiveUnits.forEach(function (size) {
    marginStyles['topMediumAndAbove-' + String(size)] = _defineProperty({}, responsive.mediumAndAbove, {
      marginTop: size * unit
    });
    marginStyles['topLargeAndAbove-' + String(size)] = _defineProperty({}, responsive.largeAndAbove, {
      marginTop: size * unit
    });
    marginStyles['bottomMediumAndAbove-' + String(size)] = _defineProperty({}, responsive.mediumAndAbove, {
      marginBottom: size * unit
    });
    marginStyles['bottomLargeAndAbove-' + String(size)] = _defineProperty({}, responsive.largeAndAbove, {
      marginBottom: size * unit
    });
    marginStyles['rightMediumAndAbove-' + String(size)] = _defineProperty({}, responsive.mediumAndAbove, {
      marginRight: size * unit
    });
    marginStyles['rightLargeAndAbove-' + String(size)] = _defineProperty({}, responsive.largeAndAbove, {
      marginRight: size * unit
    });
    marginStyles['leftMediumAndAbove-' + String(size)] = _defineProperty({}, responsive.mediumAndAbove, {
      marginLeft: size * unit
    });
    marginStyles['leftLargeAndAbove-' + String(size)] = _defineProperty({}, responsive.largeAndAbove, {
      marginLeft: size * unit
    });
    marginStyles['verticalMediumAndAbove-' + String(size)] = _defineProperty({}, responsive.mediumAndAbove, {
      marginTop: size * unit,
      marginBottom: size * unit
    });
    marginStyles['verticalLargeAndAbove-' + String(size)] = _defineProperty({}, responsive.largeAndAbove, {
      marginTop: size * unit,
      marginBottom: size * unit
    });
    marginStyles['horizontalMediumAndAbove-' + String(size)] = _defineProperty({}, responsive.mediumAndAbove, {
      marginLeft: size * unit,
      marginRight: size * unit
    });
    marginStyles['horizontalLargeAndAbove-' + String(size)] = _defineProperty({}, responsive.largeAndAbove, {
      marginLeft: size * unit,
      marginRight: size * unit
    });
  });

  return Object.assign({
    inline: {
      display: 'inline'
    },

    inlineBlock: {
      display: 'inline-block'
    }

  }, marginStyles);
})(Spacing);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/Spacing.js
// module id = 8
// module chunks = 168707334958949